/**
 * Temporary feature flag workaround until this is moved to AppConfig
 */
import { getCurrentStage } from '../../configuration/aws-exports';

// Mirrors DeploymentStage from FinSpaceWebsiteCDK/lib/config/stages.ts
enum Stage {
  LOCAL = 'local',
  DEV = 'dev',
  BETA = 'beta',
  GAMMA = 'gamma',
  PROD = 'prod',
}

const FEATURE_FLAGS = {
  // USD Nominal currency option in MFR form
  USD_NOMINAL: [Stage.DEV, Stage.BETA, Stage.GAMMA],
};

/** Check if running on localhost */
const isLocalhost = (): boolean =>
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

/**
 * Resolves the current stage, treating localhost as LOCAL
 */
const resolveStage = (): Stage => {
  if (isLocalhost()) {
    return Stage.LOCAL;
  }
  return getCurrentStage() as Stage;
};

/**
 * Checks if a feature flag is enabled for the current stage
 */
export const isFeatureEnabled = (
  flagName: keyof typeof FEATURE_FLAGS,
): boolean => {
  const currentStage = resolveStage();
  const enabledStages = FEATURE_FLAGS[flagName];
  return enabledStages?.includes(currentStage) ?? false;
};
